import React, { Component } from "react"
import PropTypes from "prop-types"
// import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import { ThemeProvider } from "styled-components"
import theme from "../styles/theme"
import GlobalStyle from "../styles/global"
import Header from "./header"
import Footer from "./footer"

const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`

const ContentsWrapper = styled.div`
  width: 86vw;
  height: 100%;
  /* min-height: 85vh; */
  max-width: 1000px;
  margin: 0 auto;
`

class Layout extends Component {
  render() {
    const { children } = this.props

    return (
      <ThemeProvider theme={theme}>
        <Container>
          <Header />
          <ContentsWrapper>
            <main>{children}</main>
          </ContentsWrapper>
          <Footer />
        </Container>
        <GlobalStyle />
      </ThemeProvider>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
